import React, { useRef, useEffect } from "react";

const ActivityFilter = ({ showFilterModal, setShowFilterModal, selectedTypes, toggleTypeFilter, clearAllFilters, selectAllFilters, activityTypes }) => {
  const filterModalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterModalRef.current && !filterModalRef.current.contains(event.target)) {
        setShowFilterModal(false);
      }
    };

    if (showFilterModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilterModal, setShowFilterModal]);

  return (
    <div className="relative">
      <button onClick={() => setShowFilterModal(!showFilterModal)} className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
        </svg>
        <span>Filtrer</span>
        {selectedTypes.length < 3 && <span className="ml-1 text-xs bg-blue-100 text-blue-800 px-1.5 py-0.5 rounded-full">{selectedTypes.length}</span>}
      </button>

      {showFilterModal && (
        <div ref={filterModalRef} className="absolute right-0 top-full mt-2 w-72 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-medium text-gray-900">Types d'activité</h3>
              <div className="flex space-x-2">
                <button onClick={selectAllFilters} className="text-xs text-blue-600 hover:text-blue-800">
                  Tout
                </button>
                <button onClick={clearAllFilters} className="text-xs text-gray-600 hover:text-gray-800">
                  Aucun
                </button>
              </div>
            </div>

            <div className="space-y-2">
              {activityTypes.map((type) => (
                <label key={type.key} className="flex items-center space-x-3 cursor-pointer">
                  <input type="checkbox" checked={selectedTypes.includes(type.key)} onChange={() => toggleTypeFilter(type.key)} className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                  <div className="flex items-center space-x-2 flex-1">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${type.color}`}>{type.label}</span>
                    <span className="text-sm text-gray-600">({type.count})</span>
                  </div>
                </label>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityFilter;
